// 公共工具类

var Common = {};
var symbols = " !\"#$%&'()*+,-./0123456789:;<=>?@";
var loAZ = "abcdefghijklmnopqrstuvwxyz";
symbols += loAZ.toUpperCase();
symbols += "[\\]^_`";
symbols += loAZ;
symbols += "{|}~";
var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

/**
 * 设备指令响应常量
 * @type {string}
 */
var SUCCESS = "00",
    CRC = "01",
    INPUT_EEROR = "02",
    DSORT = "03",
    DDID = "04",
    DDATA = "05",
    BUSY = "06",
    DOING = "10";

// 转换获取IP信息
Common.sortIP = function (str) {
    var ip = '';
    for (var i = 3; i >= 0; i--) {
        ip += parseInt(str.slice(2 * i, 2 * i + 2), 16) + ".";
    }
    return ip.slice(0, ip.length - 1);
};

// 输入 16 进制字 unicode 符串编码，返回对应的 unicode 字符
Common.hex2Str = function (str, le) {
    if (!le) {
        le = 2;
    }
    if (str) {
        if (str.length % le) {
            str = str.slice(0, str.length - str.length % le);
        }
        return String.fromCharCode.apply(new String(), (function (str) {
            var ret = [];
            for (var i = 0; i < str.length; i += le) {
                ret.push(parseInt(str.slice(i, i + le), 16));
            }
            return ret;
        })(str));
    }
    return '';
}

// 解析1字节数
Common.pbit1 = function (param, ten) {
//   debugger
    return ten ? parseAppointLen(param, 2) : parseHexAppointLen(param, 2);
};

// 1个HEX字节
Common.pbit1Hex = function (param) {
    param = appointLen(param, 2);
    param.val = reverse(param.val);
    return param;
};

// 4个HEX字节
Common.pbit4Hex = function (param) {
    param = appointLen(param, 8);
    param.val = reverse(param.val);
    return param;
};

// 1字节ASCII文本
Common.pbit1Ascii = function (param) {
    param = appointLen(param, 2);
    param.val = hex2Ascii(reverse(param.val));
    return param;
};

// 拼装1字节数
Common.abit1 = function (str) {
    var res = '';
    if (str) {
        str = parseInt(str).toString(16)
        if (str.length > 2)
            str = str.slice(0, 2);
        res = pushLength(str, 2);
    }
    return reverse(res);
};

// 解析2字节数
Common.pbit2 = function (param, ten) {
    return ten ? parseAppointLen(param, 4) : parseHexAppointLen(param, 4);
};

// 拼装2字节数
Common.abit2 = function (str) {
    var res = '';
    if (str) {
        if (str.length > 4)
            str = str.slice(0, 4);
        res = pushLength(parseInt(str).toString(16), 4);
    }
    return reverse(res);
};

// 拼装2字节数
Common.abin = function (bin, len) {
    var res = '';
    if (bin) {
        res = pushLength(parseInt(bin, 2).toString(16), len);
    }
    return reverse(res);
};

// 解析4字节数
Common.pbit4 = function (param, ten) {
    return ten ? parseAppointLen(param, 8) : parseHexAppointLen(param, 8);
};

// 拼装4字节
Common.abit4 = function (str) {
    var res = '';
    if (str) {
        if (str.length > 4)
            str = str.slice(0, 8);
        res = pushLength(parseInt(str).toString(16), 8);
    }
    return reverse(res);
};

// 获取6字节数
Common.bit6 = function (param) {
    param.val = param.data.substring(0, 12).toUpperCase();
    param.data = param.data.substring(12, param.data.length);
    return param;
};

// 解析二进制
Common.pbin2 = function (param, len, l) {
    param.val = pushLength(parseInt(reverse(param.data.substring(0, len)), 16).toString(2), l);
    param.data = param.data.substring(len, param.data.length);
    return param;
};

// 解析获取文本信息
Common.pTxt = function (param, encoding) {
    var bytes = bytesSplit(str2Bytes(param.data));
    var hex = bytes2Str(bytes.top);
    if (!encoding || 'C' == encoding || 'GBK' == encoding) {
        param.val = GBKHEX2UTF(hex);
    } else {
        param.val = UTF82UNICODE(hex);
    }
    param.data = bytes2Str(bytes.end);
    return param;
};

// 拼装获取文本信息
Common.aTxt = function (txt, encoding) {
    var hex = '';
    if (!encoding || 'C' == encoding || 'GBK' == encoding) {
        hex = UTF2GBKHEX(txt);
    } else {
        hex = UNICODE2UTF8(txt);
    }
    return hex + "00";
};

// 获取特殊浮点数
Common.pSPF = function (param) {
    var spf = parseInt(reverse(param.data.substring(0, 8)), 16);
    param.val = Number((spf >> 3)).divide(Math.pow(10, spf & 0x07));
    param.data = param.data.substring(8, param.data.length);
    return param;
}

// 浮点数 转 特殊浮点数
Common.float2SPF = function (d) {
    return Common.abit4(floatToSPF(d).toString());
};

// 时间转换
Common.pTime = function (param) {
    param = Common.pbit4(param);
    param.val = new Date((param.val + 946656000) * 1000);
    return param
};

var safeCount = function (res) {
    res += ''
    var tes = false,
        index = res.indexOf('.')
    if (index > 0 && res.length == 18) {
        tes = res.match(/[9]+[^09]{1}$/)
        if (tes) {
            return Number((+res).toFixed(tes['index'] - index - 1))
        } else {
            return Number(res.replace(/[0]+[^0]{1}$/, ''))
        }
    }
    return +res
}

Number.prototype.Minus = function (b) {
    return safeCount(this - b)
}

Number.prototype.Add = function (b) {
    return safeCount(this + b)
}

Number.prototype.Multiply = function (b) {
    return safeCount(this * b)
}

Number.prototype.divide = function (b) {
    return safeCount(this / b)
}

var HEX22CODE = function (str) {
        var ret = '', i, s = str.length - 1;
        for (i = 0; i < s; i += 2) {
            ret += pushLength(parseInt(str[i] + str[1 + i], 16).toString(2), 8, 0, true);
        }
        return ret;
    },
    hex2Ascii = function (str, open) {
        var valueStr = str.toLowerCase();
        var hex = "0123456789abcdef";
        var text = "";
        var i;

        for (i = 0; i < valueStr.length; i = i + 2) {
            var char1 = valueStr.charAt(i);
            if (char1 == ':') {
                i++;
                char1 = valueStr.charAt(i);
            }
            var char2 = valueStr.charAt(i + 1);
            var num1 = hex.indexOf(char1);
            var num2 = hex.indexOf(char2);
            var value = num1 << 4;
            value = value | num2;

            var valueInt = parseInt(value);
            var symbolIndex = valueInt - 32;
            var ch = open ? '' : '?';
            if (symbolIndex >= 0 && value <= 126) {
                ch = symbols.charAt(symbolIndex)
            }
            text += ch;
        }
        return text.toUpperCase();
    },
    ascii2Hex = function (valueStr) {
        var hexChars = "0123456789abcdef";
        var text = "";
        for (var i = 0; i < valueStr.length; i++) {
            var oneChar = valueStr.charAt(i);
            var asciiValue = symbols.indexOf(oneChar) + 32;
            var index1 = asciiValue % 16;
            var index2 = (asciiValue - index1) / 16;
            if (text != "") text += ":";
            text += hexChars.charAt(index2);
            text += hexChars.charAt(index1);
        }
        if (text.length % 2 != 0)
            text = "0" + text;
        return text;
    },
    pushLength = function (str, tarLength, def) {
        str = '' + str;
        if (str.length <= tarLength) {
            for (var i = tarLength - str.length; i > 0; i--) {
                str = def ? def : '0' + str;
            }
            return str;
        }
        return str.slice(0, tarLength);
    },
    fullHex = function (tar) {
  // debugger;
        if (tar && tar.length % 2) {
            tar = pushLength(tar, Math.floor(tar.length / 2) * 2 + 2);
        }
        return reverse(tar);
    },
    str2Hex = function (str, len) { //这里要处理 是否是ascii  16
        if (!str) {
            return '';
        }
        var ch = '',
            i,
            ret = '';
        for (i = 0; i < str.length; i++) {
            ch = str.charCodeAt(i).toString(16)
            if (len) {
                ch = pushLength(ch, len, 0, true);
            }
            ret += ch;
        }
        return ret;
    },
    reverse = function (str) {
        var ret = '';
        for (var i = str.length; i > 0; i -= 2) {
            ret += str.slice(i - 2, i);
        }
        return ret;
    },
    // 获取dId
    gtdId = function (str) {
        return fullHex(parseInt(str).toString(16));
    },
    fullLength = function (str, len) {
        if (str.length >= len) {
            return str;
        } else {
            for (var i = 0; i <= (len - str.length); i++) {
                str = '0' + str;
            }
            return str;
        }
    },
    // 获取nid
    gtNid = function (nid) {
        if (!nid)
            nid = '0';
        nid = (parseInt(nid, 16) + parseInt(Math.random() * 256)).toString(16);
        return reverse(pushLength(nid, 4));
    },
    // 数组转字符串
    list2String = function (arr) {
        var str = '';
        if (arr && arr.length > 0) {
            for (var i in arr) {
                str = arr[i] + str;
            }
        }
        return str;
    },
    // 反转二进制字符
    reverseBin = function (str) {
        var ret = '';
        for (var i = str.length - 1; i >= 0; i--) {
            ret += str.charAt(i);
        }
        return ret;
    },
    // 解析 content 定长 Int
    parseAppointLen = function (param, len) {
        param = appointLen(param, len);
        param.val = parseInt(reverse(param.val), 16);
        return param;
    },
    // 解析 content 定长 Hex
    parseHexAppointLen = function (param, len) {
        param = appointLen(param, len);
        param.val = reverse(param.val);
        return param;
    },
    // 剪切定长
    appointLen = function (param, len) {
        param.val = param.data.substring(0, len);
        param.data = param.data.substring(len, param.data.length);
        return param;
    },
    // 数据包检查格式
    checkData = function (str) {
        var start = str.slice(0, 2);
        if (!'02' == start) {
            return '';
        }

        var end = str.slice(str.length - 2, str.length);
        if (!'03' == end) {
            return '';
        }
        return str.slice(2, str.length - 2);
    },
    insertS = function (target, index, str) {
        var res = '';
        for (var i = 0; i < target.length; i++) {
            if ((i - 1) == index) {
                res += str;
            }
            res += target.charAt(i);
        }
        return res;
    },
    insertE = function (target, index, str) {
        var res = '';
        for (var i = target.length; i > 0; i--) {
            if ((target.length - i) == index) {
                res = str + res;
            }
            res = target.charAt(i - 1) + res;
        }
        return res;
    },
    floatToSPF = function (d) {
        var A,
            B;
        A = Math.floor((+d).Multiply(10000000).Add(0.5));
        B = 7;
        while (true) {
            if (B == 0) {
                if (A >= 268435456) {
                    A = 268435455;
                } else {
                    if (A < -268435456)
                        A = -268435456;
                    break;
                }
            }
            if ((A >= 268435456) || (A < -268435456)) {
                if (A > 0) {
                    A = Math.floor(A.Add(5).divide(10));
                } else {
                    A = Math.floor(A.Minus(5).divide(10));
                }
                B--;
            } else if (parseInt(A.divide(10)).Multiply(10) == A) {
                A = Math.floor(A.divide(10));
                B--;
            } else {
                break;
            }
        }
        return (A << 3) | B;
    },
    str2Bytes = function (str) {
        var pos = 0;
        var len = str.length;
        if (len % 2 != 0) {
            return null;
        }
        len /= 2;
        var hexA = new Array();
        for (var i = 0; i < len; i++) {
            var s = str.substr(pos, 2);
            var v = parseInt(s, 16);
            hexA.push(v);
            pos += 2;
        }
        return hexA;
    },
    bytes2Str = function (arr) {
        var str = "";
        for (var i = 0; i < arr.length; i++) {
            var tmp = arr[i].toString(16);
            if (tmp.length == 1) {
                tmp = "0" + tmp;
            }
            str += tmp;
        }
        return str;
    },
    bytesSplit = function (arr) {
        var top = [], end = [];
        var setway = true;
        for (var i = 0; i < arr.length; i++) {
            if (setway && arr[i] == 0X00) {
                setway = false;
                continue;
            }
            if (setway) {
                top.push(arr[i]);
            } else {
                end.push(arr[i]);
            }
        }
        return {
            top: top,
            end: end
        };
    };
module.exports = {
  Common: Common,
  fullLength:fullLength,
  reverse:reverse,
  INPUT_EEROR:INPUT_EEROR,
  pushLength:pushLength,
  parseAppointLen:parseAppointLen,
  appointLen:appointLen,
  reverse:reverse,
  fullHex:fullHex,
  gtdId:gtdId,
};



//////////////////
// WEBPACK FOOTER
// ./api/agreement/common.js
// module id = nAtw
// module chunks = 28